// Generated by `pnpm permissions` from the database roles — do not edit by hand.
// Regenerate: pnpm permissions roles generate  (needs DATABASE_URL; runs in the
// follow-up chain of `role add` / `role remove`). MSYS roles are internal and
// excluded from the organisation union on purpose.

export const organisationRoleNames = [
  "ORG_ADMIN",
  "ORG_COORDINATOR",
  "ORG_MANAGER",
  "ORG_MEMBER",
  "ORG_FINANCE",
  "ORG_SALES_MANAGER",
  "ORG_CONSULTANT",
] as const;

export type OrganisationRole = (typeof organisationRoleNames)[number];

export const projectRoleNames = [
  "PROJECT_ADMIN",
  "PROJECT_MANAGER",
  "PROJECT_MEMBER",
] as const;

export type ProjectRole = (typeof projectRoleNames)[number];
